var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"rechargeGuide"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index},[_c('p',{staticClass:"introduction"},[_vm._v(_vm._s(item.introduction))]),_vm._v(" "),_c('img',{attrs:{"src":item.imgUrl,"alt":""}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-e7292dec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/member-share/rechargeGuide.vue
// module id = i2xw
// module chunks = 1